
export const publicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDPjz3eEn9nUHRKYMyvBVbO/Ow/
+YFyAGNIiAQ1oS3O2f3YD0or0H3//wnBZUo0DCG1v33804V88i94HhAhzIQPPsFL
qqRW6idqpRNtQbULGTGLc4JsY1UhgxYgoQ6l8jUnoYtky0Y52aPCN4IQB3qX4t/z
3+FyDNcw+9IBqWUhHQIDAQAB
-----END PUBLIC KEY-----`;